import { render, staticRenderFns } from "./sonet-swiper-safe1.vue?vue&type=template&id=6ad3f12a&scoped=true&"
import script from "./sonet-swiper-safe1.vue?vue&type=script&lang=js&"
export * from "./sonet-swiper-safe1.vue?vue&type=script&lang=js&"
import style0 from "./sonet-swiper-safe1.vue?vue&type=style&index=0&id=6ad3f12a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3f12a",
  null
  
)

export default component.exports